import Vue from 'vue'
import Router from 'vue-router'
import viewRoutes from './views/views.routes'
// import componentsRoutes from './shared/components/components.routes'

Vue.use(Router)

// TODO: Remove componentsRoutes before finishing project.
const router = new Router ({
  mode: 'history',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else {
      return {x: 0, y: 0}
    }
  },
  routes: [
    ...viewRoutes
    // ...componentsRoutes
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/Test.vue'),
    // },
  ]
})

// router.beforeEach((to, from, next) => {
//   if (to.meta.requiresAuth) {
//     if (!localStorage.getItem('user-password')) next('/protected')
//     else next()
//   } else next()
// })

export default router

